<template>
  <div class="list-branch">
    <div class="row">
      <div class="col-12">
        <div class="list-branch__header">
          <h3 class="list-branch--title" v-html="branch.name"></h3>
        </div>
      </div>
      <div class="col-12">
        <div class="list-branch__map">
          <img :src="`/images/branches/${branch.id}.png`" :alt="branch.name" />
          <a target="_blank" :href="locationLink" class="list-branch--show">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 30 30"
              fill="currentColor"
            >
              <path
                d="M 24.980469 3.9902344 A 1.0001 1.0001 0 0 0 24.869141 4 L 18 4 A 1.0001 1.0001 0 1 0 18 6 L 22.585938 6 L 6 22.585938 L 6 18 A 1.0001 1.0001 0 0 0 4.984375 16.986328 A 1.0001 1.0001 0 0 0 4 18 L 4 24.847656 A 1.0001 1.0001 0 0 0 5.1523438 26 L 12 26 A 1.0001 1.0001 0 1 0 12 24 L 7.4140625 24 L 24 7.4140625 L 24 12 A 1.0001 1.0001 0 1 0 26 12 L 26 5.1269531 A 1.0001 1.0001 0 0 0 24.980469 3.9902344 z"
              ></path>
            </svg>
            <span>{{ $t("branch-list.show") }}</span>
          </a>
        </div>
      </div>
      <div class="col-12">
        <div class="list-branch__address">
          <p
            class="list-branch--text"
            v-html="branch.address"
            :title="branch.address"
          ></p>
        </div>
      </div>
      <div class="col-12">
        <div class="list-branch__hours">
          <p class="list-branch--text" v-html="branch.hours"></p>
        </div>
      </div>
      <div class="col-12">
        <div class="list-branch__button">
          <button @click="selectBranch(branch)" class="btn-primary btn--full">
            {{ $t("branch-list.choose") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouterActions from "@/mixins/routerActions";

export default {
  mixins: [RouterActions],
  data() {
    return {};
  },
  props: {
    branch: {
      type: Object,
      required: true,
    },
    mapKey: {
      type: String,
      required: true,
    },
  },
  computed: {
    locationLink() {
      return `https://www.google.com/maps/search/?api=1&query=${this.branch.lat},${this.branch.long}`;
    },
  },
  methods: {
    selectBranch(branch) {
      this.storeSetBranch(branch);
      this.$router.push({
        name: "Step 2",
        params: {
          branch: branch.id,
        },
      });
    },
  },
  created() {},
};
</script>
